module.exports = __webpack_public_path__ + "img/ball-left.88480cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/ball-left.png
// module id = gxU+
// module chunks = 15